import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import './Footer.css';

export const Footer = () => {
  return (
        <Box
      className="footer-container"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        gap: 2,
        px: { xs: 0.5, sm: 1, md: 2 },
        py: { xs: 0.5, sm: 1, md: 2 },
      }}
    >
      {/* Copyright and Version - Left side */}
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'flex-start', 
        gap: 0.25,
        flexShrink: 0,
        pl: 1,
      }}>
        <Typography 
          variant="body2" 
          sx={{ 
            fontSize: '0.7rem',
            lineHeight: '1.2',
            color: 'text.secondary',
          }}
        >
          © {new Date().getFullYear()} CyclingBuddy
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ 
            fontSize: '0.55rem',
            lineHeight: '1.2',
            color: 'text.disabled',
          }}
        >
          v0.9.1 (public beta)
        </Typography>
      </Box>

      {/* Right side group - Privacy Policy, Imprint, Help Icon */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {/* Privacy Policy */}
        <Link to="/privacy-policy" style={{ textDecoration: 'none' }}>
          <Typography 
            variant="body2" 
            sx={{ 
              fontSize: '0.7rem',
              lineHeight: '1.2',
              color: 'text.secondary',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Privacy Policy
          </Typography>
        </Link>

        {/* Imprint */}
        <Link to="/imprint" style={{ textDecoration: 'none' }}>
          <Typography 
            variant="body2" 
            sx={{ 
              fontSize: '0.7rem',
              lineHeight: '1.2',
              color: 'text.secondary',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Imprint
          </Typography>
        </Link>

        {/* Help Icon */}
        <Tooltip title="Contact" arrow>
          <IconButton 
            size="small" 
            component={Link} 
            to="/contact"
            sx={{ 
              color: 'text.secondary',
              padding: '6px',
              '&:hover': { 
                color: 'primary.main',
                backgroundColor: 'action.hover'
              }
            }}
          >
            <HelpOutlineIcon sx={{ fontSize: '1.25rem' }} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};
